const NO_INFORMATION_LABEL = 'Sin información';

const EMPTY_LABEL = '-';

export { EMPTY_LABEL, NO_INFORMATION_LABEL };
